import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCrmSettings } from './CRM/SimpleCRM/CrmSettingsContext';
import { useAppFlags } from './utils/AppFlagsContext';
import { useCompany } from './contexts/CompanyContext';
import { formatDate as fmtDate, formatDateTime } from './utils/time';
import './quotes.css'; 
import './quotes_base.css';
import { DataGrid,
         GridActionsCellItem,
 } from '@mui/x-data-grid';
import {
  Box,
  Collapse,
  Typography,
  CircularProgress,
  Paper
} from '@mui/material';

import { Delete } from '@mui/icons-material';


import { IconButton, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import SaveToLibraryDialog from './components/LibraryTemplates/SaveToLibraryDialog';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add'; // Import the Add icon
import { Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';


import { Link } from 'react-router-dom';
import { authFetch } from './utils/api';
import { authFetchRequest } from './utils/api';
import AddItem from './additem';
import CmbCustomers from './CmbCustomers'; 
//mport newCustomer from './EditCustomerDialog';
import NewCustomerDialog from './NewCustomerDialog';

import { getCookie } from './utils/cookies';
import { getFilterForUser, getStatusFilterForUser } from './utils/utils';
import { alertC, confirmC } from './components/dialogService';
import FullQuote from './records/FullQuote';
import HandlePromo from './HandlePromo';
import Packages from './Packages';
import ModalDialog from './components/ModalDialog';
import ModalDialogFinancing from './components/ModalDialogFinancing';
import EditQuoteDialog from './EditQuoteDialog';
import { get_crm_user_id, getPermissions } from './CRM/SimpleCRM/crmUtils';
import { loadStatusesFromDB } from './CRM/SimpleCRM/views/StatusManager';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField as MuiTextField } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';



const Quotes = () => {
  const location = useLocation();
  const { quoteId: selectedQuoteFromNav } = location.state || {};
  const { settings: crmSettings } = useCrmSettings();
  const { flags: appFlags } = useAppFlags();
  const promoFinancingEnabled = !!(appFlags.promotions_enabled || appFlags.financing_enabled);
  const promoFinancingButtonLabel = promoFinancingEnabled ? 'Promo/Financing' : 'Entire Quote';
  const { companyData } = useCompany();
  const tz = companyData?.timezone;
  const SIMPLE_CRM_QUOTE_MANAGER_ONLY = crmSettings.quote_manager_only;
  
  const [quotes, setQuotes] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [itemQuotes, setItemQuotes] = useState({});
  const [loadingItemQuotes, setLoadingItemQuotes] = useState(false);

  //const [rowModesModel, setRowModesModel] = useState({});

  const [showNewQuoteDialog, setShowNewQuoteDialog] = useState(false);
  // Id of a quote just created in this session — drives the one-shot pulse on
  // the Add Item button. Cleared after the animation duration.
  const [justCreatedQuoteId, setJustCreatedQuoteId] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);

  const [showDialog, setShowDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [showFullQuote, setShowFullQuote] = useState(false);
  const [showFinancing, setShowFinancing] = useState(false);
  const [showPackages, setShowPackages] = useState(false);
  // Parallel "Test" path: opens the same dialog as Packages but its PDF
  // button uses the new high-quality rendering path. Lets us iterate on
  // PDF quality side-by-side with the production Packages flow.
  const [showTest, setShowTest] = useState(false);

  const [showEditDialog, setShowEditDialog] = useState(false);
  const [quoteToEdit, setQuoteToEdit] = useState(null);

  const [perms, setPerms] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [users, setUsers] = useState([]);
  const [selectedRepId, setSelectedRepId] = useState('');

  // Status transition
  const [pipelineStatuses, setPipelineStatuses] = useState([]);
  const [advanceOpen, setAdvanceOpen] = useState(false);
  const [advanceNote, setAdvanceNote] = useState('');
  const [advancing, setAdvancing] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState([]); // quote IDs with pending approval


  // Filter rows based on search
  const filteredRows = quotes.filter((row) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    return Object.values(row).some((value) =>
      value != null && value.toString().toLowerCase().includes(searchLower)
    );
  });
  
  //=> handle add new customer
  // Close the New Quote dialog while NewCustomerDialog is open — they use
  // different stacking contexts (MUI Dialog z-index ~1300, NewCustomerDialog
  // CSS z-index 1000), and stacking modals is a worse UX than a clean swap.
  const handleAddNewCustomer = () => {
    setShowNewQuoteDialog(false);
    setShowDialog(true);
  };
  //=> end of handle add new customer

 
// Delete row
  const handleDeleteClick = (id) => async () => {
    try {
      const row = quotes.find((r) => r.id === id);
      if (!row) {
        await alertC("Row not found for ID:", id);
        return;
      }
      if (parseInt(getCookie('user_id')) !== parseInt(row.fkUserId)) {
        await alertC("You don't have permission to delete this item.");
        return;
      } 
      const confirmed = await confirmC("Are you sure you want to delete this line?");
      if (!confirmed) return;
      await authFetchRequest(`/quotes/${id}`, null, "DELETE");
      setQuotes((prevRows) => prevRows.filter((row) => row.id !== id));
      console.log(`Line ${id} deleted`);
      setExpandedRow(null);
    } catch (err) {
      console.error("Delete failed:", err);
      await alertC("Failed to delete line: " + err.message);
    }
  };
const handleViewQuote = async () => {
  setShowFullQuote(true);
}
const handlePromoFinancing = async () => {
  setShowFinancing(true);
  //alertC("handlePromoFinancing stub");
}
const handlePackages = async () => {
  setShowPackages(true);
  //alertC("handlePackages stub");
}
const handleTest = async () => {
  setShowTest(true);
}
const handleSubmitQuote = async () => {   
  const confirmed = await confirmC("Are you sure you want to submit this quote?\nThis operation is irreversible.");
  if (!confirmed) return;
  try {
      const user = localStorage.getItem("user");
      const selectedQuote = quotes.find(q => q.id === expandedRow);
      //alert(JSON.stringify(selectedQuote, null, 2));
      const quoteId = selectedQuote?.id;
      const new_status = "Quote Submitted";
      const payload = {
        current_status : selectedQuote?.status,
        new_status: new_status,
        created_by: user
      }

      const response = await authFetchRequest(
      `/quotes/${quoteId}/transition`,
      payload,
      "POST",
      { Authorization: `Bearer ${getCookie("access_token")}` }
    );

    console.log("Quote submitted:", response);
    setQuotes(prevQuotes => prevQuotes.filter(q => q.id !== quoteId));

    await alertC("Quote Submitted");
  } catch (err) {
    console.error("Failed to submit quote:", err);
    alert("Failed to submit quote: " + err.message);
  }
}



const handleCreateQuote = async (e) => {
  if (e?.preventDefault) e.preventDefault();
  if (!selectedCustomer) return;

  try {
    const user = localStorage.getItem("user");
    const timestamp = new Date().toISOString();

    const payload = {
      quote_name: `Quote for ${selectedCustomer.name}`,
      fkCustomerId: selectedCustomer.id,
      created_at: timestamp,
      reference_no: "",
      created_by: user || "Unknown",
      tags: "",
      status: "Quote",
    };

    const response = await authFetchRequest(
      `/quotes/`,
      payload,
      "POST",
      { Authorization: `Bearer ${getCookie("access_token")}` }
    );

    console.log("Quote created:", response);
    setQuotes(prevQuotes => [response, ...prevQuotes]);
    setShowNewQuoteDialog(false);
    setSelectedCustomer(null);
    // Auto-select the new quote so the details panel opens immediately, and
    // flag it for the one-shot Add Item pulse.
    setExpandedRow(response.id);
    fetchItemQuotes(response.id);
    setJustCreatedQuoteId(response.id);
    setTimeout(() => setJustCreatedQuoteId(null), 2000);
  } catch (err) {
    console.error("Failed to create quote:", err);
    alert("Failed to create quote: " + err.message);
  }
};

const checkCrmQuotes = async () => { 
  try {
    //1. import quotes from CRM
    await authFetchRequest(`/api/zoho/import-quotes`, null, "POST");
    //2. refresh grid...
    const filter = getFilterForUser();
    const status = getStatusFilterForUser('Quote')
    const updatedQuotes = await authFetch(`/quotes/quotesbyuser/${filter}${status}`);
    // 3. Update state to refresh DataGrid
    setQuotes(updatedQuotes);
    await alertC('CRM quotes imported successfully!');
  } catch (err) {
    console.error("Error importing CRM quotes:", err);
    await alertC(
      'Failed to import CRM quotes: ' + (err?.message || err) +
      '\n\nPlease contact your administrator.'
    );
  }
};

  const handleAddQuoteClick = () => {
    setShowNewQuoteDialog(true);
  };
  const handleCustomerChange = (customer) => {
    setSelectedCustomer(customer);
    console.log('Selected customer:', customer);
    // optionally trigger more UI here
  };


  const handleCloseNewQuote = () => {
    setShowNewQuoteDialog(false);
    setSelectedCustomer(null);
  };

  useEffect(() => {
    if (selectedQuoteFromNav && filteredRows.length > 0) {
      setExpandedRow(selectedQuoteFromNav);
      fetchItemQuotes(selectedQuoteFromNav);
      // Find quote position in the sorted/filtered list (DataGrid sorts by id desc)
      const sortedRows = [...filteredRows].sort((a, b) => b.id - a.id);
      const index = sortedRows.findIndex(q => q.id === selectedQuoteFromNav);
      if (index >= 0) {
        const targetPage = Math.floor(index / paginationModel.pageSize);
        setPaginationModel(prev => ({ ...prev, page: targetPage }));
      }
    }
  }, [selectedQuoteFromNav, filteredRows.length]);
  
  // Load quotes — resolve permissions first, then fetch
useEffect(() => {
  const init = async () => {
    const crmUserId = await get_crm_user_id();
    const p = getPermissions({
      crmUserId,
      crmRole:          getCookie('crm_role') || '',
      userRole:         getCookie('user_role') || '',
      userId:           getCookie('user_id'),
      quoteManagerOnly: crmSettings.quote_manager_only,
      commonCustomers:  crmSettings.common_customers,
      crmDefined:       crmSettings.external_crm !== 'none',
      simpleCrmEnabled: crmSettings.simple_crm_enabled,
    });
    setPerms(p);

    // Fetch users list for CRM manager (rep picker)
    if (p.isCrmManager) {
      try {
        const usersData = await authFetch('/users/');
        setUsers(usersData || []);
      } catch (err) {
        console.error('Failed to fetch users:', err);
      }
    }

    try {
      const data = await authFetch(p.quotesUrl);
      setQuotes(data || []);
    } catch (err) {
      console.error('Failed to fetch quotes:', err);
      if (err.message.includes('401')) handleLogout();
      setQuotes([]);
    }

    // Load pipeline statuses for Advance Status button
    const statuses = await loadStatusesFromDB();
    setPipelineStatuses(statuses.filter(s => s.position > 0));
  };

  init();
}, [crmSettings.quote_manager_only, crmSettings.common_customers, crmSettings.external_crm, crmSettings.simple_crm_enabled]); // re-run when settings load from DB

  // Fetch item quotes for selected quote
  const fetchItemQuotes = async (quoteId) => {
    setLoadingItemQuotes(true);
    try {
      const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
      setItemQuotes(prev => ({ ...prev, [quoteId]: data }));
    } catch (err) {
      console.error('Failed to fetch item quotes:', err);
      setItemQuotes(prev => ({ ...prev, [quoteId]: [] }));
      if (err.message.includes('401')) {
        handleLogout();
      }
    } finally {
      setLoadingItemQuotes(false);
    }
  };

  // Advance status — confirm dialog → log activity → transition (or submit approval request)
  const handleAdvanceStatus = async () => {
    if (!selectedQuote) return;
    const currentIdx = pipelineStatuses.findIndex(s => s.key === selectedQuote.status);
    const currentStage = pipelineStatuses[currentIdx];
    const nextStatus = pipelineStatuses[currentIdx + 1];
    if (!nextStatus) return;

    const isSalesRep = perms.isCrmSales;
    const needsApproval = isSalesRep && nextStatus.requires_approval;

    setAdvancing(true);
    try {
      if (needsApproval) {
        // Submit approval request instead of direct transition
        await authFetchRequest('/crm/approvals/', {
          quote_id:    selectedQuote.id,
          from_status: selectedQuote.status,
          to_status:   nextStatus.key,
          note:        advanceNote.trim(),
        }, 'POST');
        setPendingApprovals(prev => [...prev, selectedQuote.id]);
        setAdvanceOpen(false);
        setAdvanceNote('');
        return;
      }

      // Direct transition
      if (advanceNote.trim()) {
        await authFetchRequest('/crm/activities/', {
          customer_id: selectedQuote.fkCustomerId,
          user_id: Number(getCookie('user_id')),
          quote_id: selectedQuote.id,
          type: 'note',
          note: advanceNote.trim(),
        }, 'POST');
      }
      await authFetchRequest(`/quotes/${selectedQuote.id}/transition`, {
        current_status: selectedQuote.status,
        new_status: nextStatus.key,
        created_by: getCookie('user_id'),
      }, 'POST');
      setQuotes(prev => prev.map(q =>
        q.id === selectedQuote.id ? { ...q, status: nextStatus.key } : q
      ));
      setAdvanceOpen(false);
      setAdvanceNote('');
    } catch (err) {
      await alertC('Failed to advance status: ' + err.message);
    } finally {
      setAdvancing(false);
    }
  };

  // Handle row click
  const handleRowClick = (params) => {
    const quoteId = params.id;
    if (expandedRow === quoteId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(quoteId);
      if (!itemQuotes[quoteId]) fetchItemQuotes(quoteId);
    }
  };

  const sortModel = [
    { field: 'id', sort: 'desc' },  // Sort by 'id' in descending order
  ];

  const gridKey = perms?.isCrmSales ? 'sales' : 'admin';
  // DataGrid columns
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'quote_name', headerName: 'Quote Name', width: 200 },
    { field: 'customer_name', headerName: 'Customer', width: 150 },
    { field: 'created_at', headerName: 'Date', width: 110, editable: false,
        renderCell: (params) => fmtDate(params?.row?.created_at, tz),
     },
     ...(perms?.seeUserColumn ? [{
      field: 'user_name',
      headerName: 'User',
      width: 130,
      editable: false,
    }] : []),
     ...(perms?.seeDealerColumn ? [{
      field: 'dealer_name',
      headerName: 'Dealer',
      width: 130,
      editable: false,
    }] : []),
    { field: 'reference_no', headerName: 'Reference No. ', width: 200 },
    { field: 'tags', headerName: 'Tags', width: 150 },
    { field: 'status', headerName: 'status', width: 150 },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Del',
      width: 40,
      getActions: ({ id }) => [
        ...(perms?.canDeleteQuote ? [
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={handleDeleteClick(id)}
          />,
        ] : []),
      ],
    },
  ];


 // Save-to-library dialog state: opened by the new "Save to Lib" column.
 const [saveLibrary, setSaveLibrary] = useState({ open: false, sourceItemId: null });

 const handleCopySubItem = (itemId, quoteId) => async () => {
  try {
    const confirmed = await confirmC("Are you going to copy selected quote?");
    if (!confirmed) return;

    await authFetchRequest(`/itemquotes/${itemId}/copy`, null, "POST");

    // Refresh the list of items for the quote to include the new copy
    await fetchItemQuotes(quoteId);

    console.log(`Item ${itemId} copied`);
  } catch (err) {
    console.error("Copy failed:", err);
    await alertC("Failed to copy item: " + err.message);
  }
};

  const handleDeleteSubItem = (itemId) => async () => {
    try {
      const confirmed = await confirmC("Are you sure you want to delete this item?");
      if (!confirmed) return;

      // crmUserId isn't a component-scope variable here — fetch it the same
      // way the init() effect does, so the Zoho-sync branch can run.
      const crmUserId = await get_crm_user_id();

      // Set when the item should have been in Zoho but isn't, so we can
      // tell the user we proceeded with the local-only delete.
      let crmMissing = false;

      if (crmSettings.external_crm !== 'none' && (crmUserId !== "NA")){
        const zohoQuoteId = selectedQuote?.crm_quote_id || null;

        // Only sync to Zoho if this quote is actually CRM-linked.
        if (zohoQuoteId) {
          const data = await authFetch(`/itemquotes/${itemId}`);
          const productId = data?.crm_product_id || null;

          if (productId) {
            try {
              // 1. remove product from quote
              await authFetchRequest(
                `/api/zoho/modify-quote-product/${zohoQuoteId}/${productId}`,
                { action: "remove" },
                "POST",
                { Authorization: `Bearer ${getCookie("access_token")}` }
              );
              // 2. delete product completely
              await authFetchRequest(`/api/zoho/delete-product/${productId}`, null, "DELETE");
            } catch (zerr) {
              // Treat "not found in CRM" as a soft failure — the user still
              // wants the local item gone. Backend wraps Zoho's 4xx as a 500
              // with the original status/message in the body, so match loosely.
              const msg = zerr?.message || '';
              const looksMissing =
                /\b404\b/.test(msg) ||
                /\b400\b/.test(msg) ||
                /not found/i.test(msg) ||
                /ids=null/i.test(msg);
              if (looksMissing) {
                crmMissing = true;
              } else {
                throw zerr;
              }
            }
          } else {
            // CRM-linked quote, but this item has no crm_product_id (stale
            // data or original create-sync failed). Nothing to remove in Zoho.
            crmMissing = true;
          }
        }
      }

      await authFetchRequest(`/itemquotes/${itemId}`, null, "DELETE");

      // Update local state (e.g. quoteItems) to remove the deleted item
      setItemQuotes(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(quoteId => {
          updated[quoteId] = updated[quoteId].filter(item => item.id !== itemId);
        });
        return updated;
      });

      console.log(`Item ${itemId} deleted`);

      if (crmMissing) {
        await alertC("Item not found in CRM — deleted in platform only.");
      }
    } catch (err) {
      console.error("Delete failed:", err);
      await alertC("Failed to delete item: " + err.message);
    }
  };
  
//==>
  // Get current item quotes safely
  const quoteItems = Array.isArray(itemQuotes[expandedRow])
    ? itemQuotes[expandedRow]
    : [];
   // alert(JSON.stringify(quoteItems, null, 2));
  const selectedQuote = quotes.find(q => q.id === expandedRow);
  const fkCustomerId  = selectedQuote?.fkCustomerId;
  const fkUserId      = selectedQuote?.fkUserId;
  const status        = selectedQuote?.status;
  const reference_no  = selectedQuote?.reference_no;
  /*{
    "id": 3,
    "quote_name": "Auto-1",
    "fkCustomerId": 2,
    "created_at": "2025-04-23T21:07:11",
    "reference_no": "ref my",
    "created_by": null,
    "tags": "2-nd floor",
    "customer_name": "Pilco Inc.",
    "fkUserId": 2,
    "user_name": "user2",
    "status": "Quote"
  },*/

  return (    
    <Box 
      justifyContent="space-between" 
      alignItems="center" 
      width="100%"
      minHeight="100vh"           // ← just ensures it fills at least one screen
      sx={{ paddingBottom: 8 }}   // ← tiny breathing room at bottom
    >
      {/* Add New Quote Button */}
      <Paper sx={{ p: 1, pb: 1.2, marginBottom: 2 }}>
      <h3>Quotes</h3>
      {perms?.canAddQuote && (
        <span>
        <Button
          size="small"
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAddQuoteClick}
        >
          New Quote
        </Button>
        </span>
      )}
      {/* Edit Quote button — appears only when a quote is selected */}
      {expandedRow && selectedQuote?.status === 'Quote' && perms?.canEditQuote && (
        <span>
          <Button sx={{fontSize: '12px'}}
            size="small"
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => {
              setQuoteToEdit(selectedQuote);
              setShowEditDialog(true);
            }}
          >
            Edit Quote
          </Button>
        </span>
      )}

    {/* Advance Status button — when a quote is selected and there's a next stage */}
    {expandedRow && selectedQuote && (() => {
      const currentIdx = pipelineStatuses.findIndex(s => s.key === selectedQuote.status);
      const currentStage = pipelineStatuses[currentIdx];
      const nextStatus = pipelineStatuses[currentIdx + 1];
      if (!nextStatus) return null;
      const isSalesRep = perms.isCrmSales;
      const blocked = isSalesRep && currentStage && !currentStage.sales_rep_can_advance;
      const needsApproval = isSalesRep && nextStatus.requires_approval;
      const hasPending = pendingApprovals.includes(selectedQuote.id);
      if (hasPending) return (
        <Chip label="⏳ Approval Pending" size="small" sx={{ bgcolor: '#fff3e0', color: '#e65100', fontWeight: 'bold', border: '1px solid #ffcc80' }} />
      );
      return (
        <Tooltip title={blocked ? 'Only a manager can advance from this stage' : ''}>
          <span>
            <Button
              sx={{ fontSize: '12px' }}
              size="small"
              variant="outlined"
              color={needsApproval ? 'warning' : 'success'}
              startIcon={<ArrowForwardIcon />}
              onClick={() => setAdvanceOpen(true)}
              disabled={blocked}
            >
              {needsApproval ? `Request Approval → ${nextStatus.key}` : `→ ${nextStatus.key}`}
            </Button>
          </span>
        </Tooltip>
      );
    })()}

    {/* Right Side: Archive Link */}
    {!perms?.isCrmSales && (
    <span>
      <Link to="/archive" style={{ textDecoration: 'none' }}>
        <Button 
        size="small"
        variant="outlined" color="secondary" sx={{fontSize: '12px'}}>
          View Archive
        </Button>
      </Link>
      </span>
    )}


      <span>
        {perms?.isZohoUser && (
        <Button sx={{fontSize: '12px'}}
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<AddIcon />}
          onClick={checkCrmQuotes}
        >
          Load CRM Quotes
        </Button>
        )}
      </span>

      </Paper>
      <Dialog open={showNewQuoteDialog} onClose={handleCloseNewQuote} maxWidth="xs" fullWidth>
        <form onSubmit={handleCreateQuote}>
          <DialogTitle sx={{ fontSize: '15px' }}>New Quote</DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', paddingTop: 4 }}>
              {SIMPLE_CRM_QUOTE_MANAGER_ONLY && perms?.isCrmManager && users.length > 0 && (
                <FormControl size="small" fullWidth>
                  <InputLabel sx={{ fontSize: '13px' }}>Sales Rep</InputLabel>
                  <Select
                    value={selectedRepId}
                    onChange={(e) => { setSelectedRepId(e.target.value); setSelectedCustomer(null); }}
                    label="Sales Rep"
                    sx={{ fontSize: '13px', height: '2.5em' }}
                  >
                    <MenuItem value="">All Reps</MenuItem>
                    {users.map(u => (
                      <MenuItem key={u.id} value={u.id}>{u.fullName || u.username || `User #${u.id}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <CmbCustomers
                value={selectedCustomer}
                onChange={handleCustomerChange}
                onAddNew={handleAddNewCustomer}
                customers={customers}
                setCustomers={setCustomers}
                showAll={perms?.isCrmManager}
                filterUserId={SIMPLE_CRM_QUOTE_MANAGER_ONLY && perms?.isCrmManager ? selectedRepId : null}
                showUserName={SIMPLE_CRM_QUOTE_MANAGER_ONLY && perms?.isCrmManager}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNewQuote}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!selectedCustomer}
              startIcon={<AddIcon />}
            >
              Create Quote
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <NewCustomerDialog
        show={showDialog}
        onClose={() => { setShowDialog(false); setShowNewQuoteDialog(true); }}
        overrideUserId={SIMPLE_CRM_QUOTE_MANAGER_ONLY && perms?.isCrmManager && selectedRepId ? selectedRepId : null}
        onCustomerAdded={(newCustomer) => {
          setCustomers(prev => [...prev, newCustomer]);
          setSelectedCustomer(newCustomer);
          setShowNewQuoteDialog(true);
        }}
      />
      <Paper
  elevation={1}
  sx={{
    p: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    mb: 2,
    borderRadius: 3,
  }}
>
  <SearchIcon sx={{ color: 'action.active', mx: 1 }} />
  <InputBase
    placeholder="Search quotes..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    sx={{ ml: 1, flex: 1 }}
    inputProps={{ 'aria-label': 'search quotes' }}
  />
</Paper>
      <div style={{ height: 300, width: '100%' }}>
        <DataGrid
          key={gridKey}
          pageSize={10}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          rowsPerPageOptions={[10, 20, 50]} // 👈  dropdown options
          pageSizeOptions={[10, 20, 50]}    // 👈 fallback for older versions

          rows={filteredRows}   /* rows={quotes} ← CHANGE THIS */
          columns={columns}
          getRowId={(row) => row.id}
          headerHeight={30}
          rowHeight={25}

          sortModel={sortModel}  // Set the default sort model


          sx={{
            fontSize: '13px',
            lineHeight: '1.35 !important',
            backgroundColor: 'transparent',
            border: 'none',
            '& .MuiDataGrid-virtualScroller': { backgroundColor: 'transparent' },
            '& .MuiDataGrid-footerContainer': { backgroundColor: 'transparent', borderTop: '1px solid #e0e0e0' },
            '& .MuiDataGrid-withBorderColor': { borderColor: '#e0e0e0' },

        
            // Header
            '& .MuiDataGrid-columnHeader': {
              height: '42px !important',
              padding: '0 10px !important',
              backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: '12.5px !important',
              fontWeight: 600,
            },

            // Cells
            '& .MuiDataGrid-cell': {
              padding: '0 10px !important',
              fontSize: '13px !important',
            },

            // Rows
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
            },
        
            // Selected row
            '& .MuiDataGrid-row.Mui-selected': {
              backgroundColor: '#e3f2fd !important',
            },
            '& .MuiDataGrid-row.Mui-selected:hover': {
              backgroundColor: '#bbdefb !important',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5faff !important',
            },
        
            // Toolbar (search, pagination)
            '& .MuiDataGrid-toolbarContainer': {
              padding: '8px 12px !important',
              minHeight: '15px !important',
            },
            '& .MuiDataGrid-toolbarContainer input, & .MuiDataGrid-toolbarContainer select': {
              fontSize: '13px !important',
              height: '36px !important',
            },
        
            // Pagination
            '& .MuiTablePagination-root, & .MuiTablePagination-toolbar': {
              minHeight: '38px !important',
              height: '38px !important',
              alignItems: 'center',
              padding: '0 4px',
            },
            '& .MuiTablePagination-select': {
              height: '28px !important',
              fontSize: '13px',
              padding: '2px 20px 2px 6px !important',
            },
        
            // Icons
            '& .MuiSvgIcon-root': {
              fontSize: '18px !important',
            },
        
            // Remove default border bloat
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden',

            // Remove cell focus outline
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none !important',
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
              outline: 'none !important',
            },
          }}
          onRowClick={handleRowClick}
          rowSelectionModel={expandedRow ? [expandedRow] : []}
          disableMultipleRowSelection={true}
        />
      </div>

    {expandedRow && (
    <Collapse in={true} timeout="auto" unmountOnExit>
    <Paper elevation={1} sx={{ mt: 2, p: 2, backgroundColor: '#f9f9f9' }}>
      <Typography variant="h6" sx={{ fontSize: '14px' }}>
        Quote #{expandedRow} Details &nbsp;
        {selectedQuote?.fk_lead_id && (
          <Typography component="span" variant="body2" sx={{ color: 'text.secondary', fontWeight: 'normal', fontSize: '12px' }}>
            — Lead #{selectedQuote.fk_lead_id}
            {selectedQuote.lead_name ? `: ${selectedQuote.lead_name}` : ''}
            {selectedQuote.lead_source ? ` (${selectedQuote.lead_source})` : ''}
          </Typography>
        )}

        {quoteItems.length > 0 && selectedQuote?.status === 'Quote' && (parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (
          <span>
            <Button
              size="small"
                sx={{
                    width: '100%',
                    maxWidth: '100px',
                    height: '2.0em',
                    fontSize: '12px',
                    marginBottom: '5px',
                    color: 'red', // sets the font color to red
                    borderColor: 'red', // optional: sets border color to match
                    '&:hover': {
                      borderColor: 'darkred', // optional: change on hover
                      color: 'darkred',       // optional: change font on hover
                    }
                }}
              variant="outlined"
              color="secondary"
              onClick={handleSubmitQuote}
              >
              Submit Quote
            </Button>
          </span>
        )}

        {/*View Full Quote button commented below, not in use anymore*/}
        {false && quoteItems.length > 0 && selectedQuote?.status === 'Quote' &&  ( 
          <span>
            <Button sx={{ width: '100%', maxWidth: '125px', height: '2.0em', fontSize: '12px', marginBottom: '5px' }}
              size="small"
              variant="outlined"
              color="secondary"
              onClick={handleViewQuote}
              >
              View Full Quote
            </Button>
          </span>
        )}
        
        {quoteItems.length > 0 && selectedQuote?.status === 'Quote' &&  (
          <span>
            <Button sx={{ width: '100%', maxWidth: '125px', height: '2.0em', fontSize: '12px', marginBottom: '5px' }}
              size="small"
              variant="outlined"
              color="secondary"
              onClick={handlePromoFinancing}
              >
              {promoFinancingButtonLabel}
            </Button>
          </span>
          )}
        {quoteItems.length > 0 && selectedQuote?.status === 'Quote' &&  (
          <span>
            <Button sx={{ width: '100%', maxWidth: '125px', height: '2.0em', fontSize: '12px', marginBottom: '5px' }}
              size="small"
              variant="outlined"
              color="secondary"
              onClick={handlePackages}
              >
              Packages
            </Button>
          </span>
          )}
        {/* Test button - hidden in production, flip `false` to true to
            re-enable for PDF-pipeline iteration. Keeps the parallel
            ModalDialogFinancing instance below available without
            cluttering the user-facing toolbar. */}
        {false && quoteItems.length > 0 && selectedQuote?.status === 'Quote' &&  (
          <span>
            <Button sx={{ width: '100%', maxWidth: '125px', height: '2.0em', fontSize: '12px', marginBottom: '5px' }}
              size="small"
              variant="outlined"
              color="warning"
              onClick={handleTest}
              >
              Test
            </Button>
          </span>
          )}
      </Typography>
      <ModalDialog
        show={showFullQuote}
        onClose={() => setShowFullQuote(false)}
        title="Full Quote"
        quoteId={selectedQuote?.id}
      >
        <FullQuote quoteId={selectedQuote?.id} showLinePrices={true} documentType='Quote' />
      </ModalDialog>

    
      <ModalDialogFinancing
        show={showFinancing}
        onClose={() => setShowFinancing(false)}
        title1="Promotions & Financing"
        quoteId={selectedQuote?.id}
      >
        <HandlePromo
          quoteId={selectedQuote?.id}
          showLinePrices={true}
          documentType="Quote"
          isOpen={showFinancing}
        />
      </ModalDialogFinancing>

      <ModalDialogFinancing
        show={showPackages}
        onClose={() => setShowPackages(false)}
        quoteId={selectedQuote?.id}
      >
        <Packages
          quoteId={selectedQuote?.id}
          showLinePrices={true}
          documentType="Quote"
          isOpen={showPackages}
        />
      </ModalDialogFinancing>

      {/* Parallel "Test" dialog — same content as Packages, but its PDF
          button uses the new high-quality rendering pipeline. The
          testMode prop is the only differentiator. */}
      <ModalDialogFinancing
        show={showTest}
        onClose={() => setShowTest(false)}
        quoteId={selectedQuote?.id}
        testMode={true}
      >
        <Packages
          quoteId={selectedQuote?.id}
          showLinePrices={true}
          documentType="Quote"
          isOpen={showTest}
        />
      </ModalDialogFinancing>
      
      <EditQuoteDialog
        open={showEditDialog}
        onClose={() => {
          setShowEditDialog(false);
          setQuoteToEdit(null);
        }}
        quote={quoteToEdit}
        onQuoteUpdated={(updatedQuote) => {
          setQuotes(prev => prev.map(q => q.id === updatedQuote.id ? updatedQuote : q));
          setQuoteToEdit(updatedQuote); // optional: keep fresh data
        }}
      />

      {loadingItemQuotes ? (
        <CircularProgress />
      ) : quoteItems.length > 0 ? (
        <>
          {/* Table layout for better alignment */}
          <table className="table-sm" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>Sub ID</th>
                <th>Item</th>
                <th>Type</th>
                <th style={{ width: '100px' }}>created at</th>
                <th style={{ width: '100px' }}>updated at</th>

                <th style={{ width: '100px' }}>Subtotal</th>
                <th style={{ width: '100px' }}> Tax</th>
                <th style={{ width: '100px' }}>Total</th>
                <th style={{ width: '20px' }}>Qty</th>
                <th style={{ width: '40px' }}>Edit</th>
                <th style={{ width: '40px' }} >Delete</th>
                <th style={{ width: '40px' }} >Copy</th>
                <th style={{ width: '50px' }} >to lib</th>
              </tr>
            </thead>
            <tbody>
              {quoteItems.map(item => (
                <tr 
                    key={item.id} 
                    className={selectedRow === item.id ? "selected-row" : "hover-row"}


                    onClick={() => setSelectedRow(item.id)} // ✅ Update selection on row click
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}                  
                >

                  <td>{item.subId}</td>
                  <td>{item?.doorData?.frameData?.selectedDoor?.name}</td>
                  <td>{item?.doorData?.document?.type}</td>
                  <td>{item?.created_at ? formatDateTime(item.created_at, tz) : 'N/A'}</td>
                  <td>{item?.updated_at ? formatDateTime(item.updated_at, tz) : 'N/A'}</td>
                  <td>{item?.doorData?.calc?.subtotal}</td>
                  <td>{item?.doorData?.calc?.tax}</td>
                  <td>{item?.doorData?.calc?.total}</td>
                  <td>{item?.doorData?.frameData?.quantity}</td>
                  <td>
                  {/*console.log('maremala:' + JSON.stringify({item}, null, 2))*/}
                    <Link to={`/${item.itemType}`} state={{ quoteId: item.fkQuoteId, quoteItemId: item.id, 
                                                            fkCustomerId: fkCustomerId, fkUserId: fkUserId, subId: item.subId,
                                                            reference_no: reference_no  }}>
                      <Tooltip title="Edit Item">
                        <IconButton size="small" color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </td>
                  <td>
                  {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
                      <Tooltip title="Delete Item">
                        <IconButton size="small" color="primary" onClick={handleDeleteSubItem(item.id)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>   
                    ) : null}                
                  </td>
                  <td>
                  {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
                      <Tooltip title="Copy Item">
                        <ContentCopyIcon size="small" color="primary" onClick={handleCopySubItem(item.id, item.fkQuoteId)}>
                          <ContentCopyIcon fontSize="small" />
                        </ContentCopyIcon>
                      </Tooltip>
                    ) : null}
                  </td>
                  <td>
                  {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
                      <Tooltip title="Save to my library">
                        <LibraryAddIcon
                          fontSize="small"
                          color="primary"
                          style={{ cursor: 'pointer' }}
                          onClick={() => setSaveLibrary({ open: true, sourceItemId: item.id })}
                        />
                      </Tooltip>
                    ) : null}
                  </td>
                </tr>
              ))}
            <tr><td colSpan="13">&nbsp;</td></tr>
            <tr>
                <th colSpan="5">Grand Totals</th>
                <th style={{ width: '120px' }}>Grand Subtotal</th>
                <th style={{ width: '100px' }}>Grand Tax</th>
                <th style={{ width: '100px' }}>Grand Total</th>
                <th colSpan="5"></th>
            </tr>
            <tr>
                <td colSpan="5"></td>
                <td style={{ width: '120px' }}>
                $
                {quoteItems
                .reduce((sum, item) => sum + (parseFloat(item.doorData?.calc?.subtotal) || 0), 0)
                .toFixed(2)}
                </td>
                <td style={{ width: '100px' }}>
                $
                {quoteItems
                .reduce((sum, item) => sum + (parseFloat(item.doorData?.calc?.tax) || 0), 0)
                .toFixed(2)}
                </td>
                <td style={{ width: '100px' }}>
                $
                {quoteItems
                .reduce((sum, item) => sum + (parseFloat(item.doorData?.calc?.total) || 0), 0)
                .toFixed(2)}
                </td>
                <td colSpan="5"></td>
            </tr>
            <tr></tr>
            </tbody>
          </table>

          {/* AddItem component */}
          {/*console.log('maremela:' + JSON.stringify({expandedRow}, null, 2))*/}
          {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
            <AddItem
              quoteId={expandedRow}
              fkCustomerId={fkCustomerId}
              fkUserId={fkUserId}
              reference_no={reference_no}
              pulse={expandedRow === justCreatedQuoteId}
              onItemAdded={() => fetchItemQuotes(expandedRow)} /* refresh sub-items after library-add */
            />
          ) : null}

          {/* Save-to-library prompt, opened by the "Save to Lib" column. */}
          <SaveToLibraryDialog
            open={saveLibrary.open}
            sourceItemId={saveLibrary.sourceItemId}
            onClose={() => setSaveLibrary({ open: false, sourceItemId: null })}
          />
        </>
      ) : (
        <>
        <Typography variant="body2" color="textSecondary">
          No items found.
        </Typography>
        <div>
        {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
            <AddItem
                 quoteId={selectedQuote.id} fkCustomerId={selectedQuote?.fkCustomerId}
                 fkUserId={selectedQuote?.fkUserId} reference_no={selectedQuote?.reference_no}
                 pulse={selectedQuote.id === justCreatedQuoteId}
            />
          ) : null} 
        </div>
        </>    
      )}
    </Paper>
  </Collapse>

         )}

    {/* Advance Status dialog */}
    {advanceOpen && selectedQuote && (() => {
      const currentIdx = pipelineStatuses.findIndex(s => s.key === selectedQuote.status);
      const nextStatus = pipelineStatuses[currentIdx + 1];
      const isSalesRep = perms.isCrmSales;
      const needsApproval = isSalesRep && nextStatus?.requires_approval;
      const noteRequired = crmSettings.require_transition_note || needsApproval;
      return (
        <Dialog open onClose={() => { setAdvanceOpen(false); setAdvanceNote(''); }} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontSize: '15px' }}>
            {needsApproval
              ? `Request Approval: ${selectedQuote.status} → ${nextStatus?.key}`
              : `Advance: ${selectedQuote.status} → ${nextStatus?.key}`}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ mb: 1.5, color: 'text.secondary' }}>
              Quote #{selectedQuote.id} — {selectedQuote.quote_name}
            </Typography>
            {needsApproval && (
              <Typography variant="caption" sx={{ display: 'block', mb: 1, color: '#e65100', bgcolor: '#fff3e0', p: 1, borderRadius: 1 }}>
                This stage requires manager approval. Your request will be reviewed before the quote advances.
              </Typography>
            )}
            <MuiTextField
              label={noteRequired ? 'Note (required)' : 'Add a note (optional)'}
              fullWidth
              multiline
              rows={3}
              size="small"
              value={advanceNote}
              onChange={e => setAdvanceNote(e.target.value)}
              placeholder="e.g. Quote sent via email, awaiting response..."
              autoFocus
              required={noteRequired}
              error={noteRequired && advanceNote.trim() === ''}
              helperText={noteRequired && advanceNote.trim() === '' ? 'A note is required.' : ''}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setAdvanceOpen(false); setAdvanceNote(''); }}>Cancel</Button>
            <Button
              variant="contained"
              color={needsApproval ? 'warning' : 'success'}
              onClick={handleAdvanceStatus}
              disabled={advancing || (noteRequired && advanceNote.trim() === '')}
              startIcon={<ArrowForwardIcon />}
            >
              {advancing
                ? (needsApproval ? 'Submitting...' : 'Advancing...')
                : (needsApproval ? 'Submit for Approval' : `Move to ${nextStatus?.key}`)}
            </Button>
          </DialogActions>
        </Dialog>
      );
    })()}

    </Box>
  );
};

export default Quotes;
